import { put, takeEvery } from "redux-saga/effects";
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, tokenUser, infoUser } from "./actions";
import { jwtDecode } from "jwt-decode";

function* loginUser({ payload: { token, history } }) {
  try {
    localStorage.setItem("accessToken", token);
    yield put(loginSuccess());
    yield put(tokenUser(token));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("accessToken");
    put(tokenUser(""));
    put(infoUser({}));
    history('/login');
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
